// == Import : npm
import React from 'react';

// == Import : local
import '../../style/style.scss';
import Header from '../../containers/Header';
import { boEntries } from '../../utils/headerEntries.js';
import ImagePickerMedia from '../../containers/ImagePickerMedia';

// == Composant
const Media = ({ location, match, datas, waitingRequest, getTools, deleteEntity, connected }) => {

    return (
    <>
    <Header currentMenuItem={12} entries={boEntries} location={location} match={match} />
    <div className='page-wrapper' style={{ paddingLeft:'20%', paddingRight:'20%' }}>
        <div style={{ display:'flex', justifyContent: 'space-between', margin:'100px 0% 0 0' }}>
            <h1 className='page-title'>Media</h1>
        </div>
        <ImagePickerMedia setPickImage={''} onClick={(e) => {console.log(e);}} />
    </div>
    </>
    )
};

// == Export
export default Media;
